<template>
  <div class="bg-gray  mb-3 ">
    <router-view/>
    <div class="row p-3 ">
      <div class="col-12">
        <div class="header-button">
          <a class="btn btn-common " @click="showListMaster()"> مشاهده ادامه عناوین پایان نامه کارشناسی ارشد </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ListThesisVueRoute",
  data() {
    return {
      count: 50,
    }
  },
  methods: {
    showListMaster() {
      if (this.count > 400) this.count = 50;
      this.$router.push('/' + this.count);
      this.count = this.count + 25;
    },
  },
}
</script>
<style scoped>
</style>